export default "__VITE_ASSET__CRm4K58T__"